export default __webpack_public_path__ + "static/media/sticky-ticket.23c60daa.svg";